import React, { useState } from 'react';
import { stockService } from '../services/api';
import './Login.css';

const Login = ({ setAuth }) => {
    const [credentials, setCredentials] = useState({ username: '', password: '' });

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await stockService.login(credentials.username, credentials.password);
        if (res.success) {
            localStorage.setItem('user', JSON.stringify(res.user));
            localStorage.setItem('isLogged', 'true'); // Indispensable pour ton App.js
            setAuth(true);
        } else {
            alert("Identifiants incorrects");
        }
    };

    return (
        <div className="login-container">
            <form className="login-form" onSubmit={handleSubmit}>
                <h2>Accès Stock</h2>
                <input
                    type="text"
                    placeholder="Utilisateur"
                    required
                    onChange={e => setCredentials({ ...credentials, username: e.target.value })}
                />
                <input
                    type="password"
                    placeholder="Mot de passe"
                    required
                    onChange={e => setCredentials({ ...credentials, password: e.target.value })}
                />
                <button type="submit">Se connecter</button>
            </form>
        </div>
    );
};

export default Login;